module.exports = __webpack_public_path__ + "static/media/01-mobile.4e597b15.webp";